import React from 'react'
import { prepareData } from 'utils/googleData'


export const EventDisclaimer = (props) => {
    const {
        enable,
        direction,
        text
    } = prepareData({ props })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
        return (
            <div direction={direction}>
            <p className="mt-3 !leading-tight">
            <small className=" opacity-75 ">{text}</small>
        </p>
        </div>
        )
    }
export default EventDisclaimer
